import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const cadastrar = ({ cd_ponto_apoio, equipamentos }) => {
  return axios.post(
    process.env.URL_API_BASE + '/distribuicao-lote',
    {
      cd_ponto_apoio: cd_ponto_apoio,
      equipamentos: equipamentos,
      idc_status: 1,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterar = ({ id, cd_ponto_apoio, equipamentos, idc_status }) => {
  return axios.patch(
    process.env.URL_API_BASE + '/distribuicao-lote/' + id,
    {
      cd_ponto_apoio: cd_ponto_apoio,
      equipamentos: equipamentos,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listar = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/distribuicao-lote',
    config
  )
  return response.data
}

const listarPorStatus = async status => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/distribuicao-lote' +
      (status !== null && status !== undefined
        ? '/listar-por-status/' + status
        : ''),
    config
  )
  return response.data
}

const obter = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/distribuicao-lote/' + id,
    config
  )
  return response.data
}

const listarEquipamentosLote = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/distribuicao-lote-equipamento/equipamentos/' +
      id,
    config
  )
  return response.data
}

const alterarStatusParaSaiuParaEntrega = id => {
  return axios.patch(
    process.env.URL_API_BASE +
      '/distribuicao-lote/marcar-saiu-para-entrega/' +
      id,
    {
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

export default {
  cadastrar,
  alterar,
  listar,
  listarPorStatus,
  obter,
  alterarStatusParaSaiuParaEntrega,
  listarEquipamentosLote
}



// WEBPACK FOOTER //
// ./src/actions/DistribuicaoLoteActions.js